<div id="iccForm">
    <span *ngIf="title" class="text-3xl font-semibold">{{ title }}</span>
    <div *ngIf="icc" class="pb-0 m-0 overflow-auto">
        <form [formGroup]="iccFormGroup">
            <div class="grid grid-cols-1 md:grid-cols-3 gap-4 w-full">
                <mat-form-field dense appearance="outline" floatLabel="always" class="col-span-2 flex items-center justify-center">
                    <mat-label>Nombre</mat-label>
                    <input name="name" formControlName="name" matInput required>
                </mat-form-field>
                <mat-form-field dense appearance="outline" floatLabel="always" class="flex items-center justify-center">
                    <mat-label>Versión</mat-label>
                    <input name="version" formControlName="version" matInput>
                </mat-form-field>
            </div>
            <div class="grid grid-cols-1 md:grid-cols-3 gap-4 w-full">
                <mat-form-field dense appearance="outline" floatLabel="always" class="flex items-center justify-center">
                    <mat-label>Tipo ICC</mat-label>
                    <mat-select formControlName="iccType">
                        <mat-option value=""></mat-option>
                        <mat-option value="Plantilla Excel">Plantilla Excel</mat-option>
                        <mat-option value="Valores Flexibles">Valores Flexibles</mat-option>
                        <mat-option value="Solo Valores">Solo Valores</mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field dense appearance="outline" floatLabel="always" class="flex items-center justify-center">
                    <mat-label>Procedimiento</mat-label>
                    <input name="procedure" formControlName="procedure" matInput>
                </mat-form-field>
                <mat-form-field dense appearance="outline" floatLabel="always" class="flex items-center justify-center">
                    <mat-label>Ruta Archivo</mat-label>
                    <input name="filePath" formControlName="filePath" matInput>
                </mat-form-field>
            </div>
            <div *ngIf="iccFormGroup.get('iccType').value === 'Valores Flexibles'" class="grid grid-cols-1 md:grid-cols-3 gap-4 w-full">
                <mat-form-field dense appearance="outline" floatLabel="always" class="flex items-center justify-center col-span-3">
                    <mat-label>Definición de valores posibles</mat-label>
                    <textarea name="dataFormat" formControlName="dataFormat" rows="4" matInput></textarea>
                </mat-form-field>
            </div>
            <div class="grid grid-cols-1 md:grid-cols-3 gap-4 w-full">
                <mat-form-field dense appearance="outline" floatLabel="always" class="flex items-center justify-center">
                    <mat-label>Descripción</mat-label>
                    <textarea name="description" formControlName="description" rows="3" matInput></textarea>
                </mat-form-field>
                <mat-form-field dense appearance="outline" floatLabel="always" class="flex items-center justify-center col-span-2">
                    <mat-label>Descripción AI</mat-label>
                    <textarea name="aiDescription" formControlName="aiDescription" rows="3" matInput></textarea>
                </mat-form-field>
            </div>
            <div class="grid grid-cols-1 md:grid-cols-1 gap-4 w-full">
                <mat-form-field dense appearance="outline" floatLabel="always" class="flex items-center justify-center">
                    <mat-label>Magnitudes posibles</mat-label>
                    <mat-chip-list #chipList aria-label="Selección de magnitudes">
                        <mat-chip
                            *ngFor="let magnitud of selectedMagnitudes"
                            [selectable]="true"
                            [removable]="true"
                            (removed)="remove(magnitud)">
                            {{magnitud}}
                            <mat-icon matChipRemove>cancel</mat-icon>
                        </mat-chip>
                        <input
                            placeholder="Buscar magnitudes..."
                            #magnitudInput
                            [formControl]="magnitudCtrl"
                            [matAutocomplete]="auto"
                            [matChipInputFor]="chipList"
                            [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                            (matChipInputTokenEnd)="add($event)">
                    </mat-chip-list>
                    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectMagnitud($event)">
                        <mat-option *ngFor="let magnitud of filteredMagnitudes | async" [value]="magnitud">
                            {{magnitud}}
                        </mat-option>
                    </mat-autocomplete>
                    <!-- Campo oculto para mantener compatibilidad con el formulario -->
                    <input type="hidden" name="posibleMagnitudes" formControlName="posibleMagnitudes">
                </mat-form-field>
            </div>
            <div class="flex items-center mt-2">
                <mat-checkbox formControlName="hasCalibrator">¿Tiene calibrador?</mat-checkbox>
            </div>
            <div *ngIf="iccFormGroup.get('hasCalibrator').value" class="grid grid-cols-1 md:grid-cols-3 gap-4 w-full mt-2">
                <mat-form-field dense appearance="outline" floatLabel="always" class="col-span-3 flex items-center justify-center w-full">
                    <mat-label>Calibradores</mat-label>
                    <input name="calibrators" formControlName="calibrators" matInput />
                </mat-form-field>
            </div>
        </form>
        <div *ngIf="_systemService.canAction('adminClients')" class="flex justify-end gap-4 mt-4">
            <button mat-button mat-raised-button color="warn" (click)="deleteICC()" [disabled]="iccFormGroup.invalid" aria-label="DELETE">Borrar</button>
            <button mat-button mat-raised-button color="accent" (click)="guardarICC()" [disabled]="iccFormGroup.invalid" aria-label="SAVE">Guardar</button>
        </div>
    </div>
    <div *ngIf="!icc">
        <span>Debe seleccionar un ICC para modificar o presionar 'Nuevo' para crear uno nuevo</span>
    </div>
</div>
